import { createSelector } from 'reselect';

export const getById = ({ cosAnnexeTR }) => cosAnnexeTR.byId;
export const getIds = ({ cosAnnexeTR }) => cosAnnexeTR.list.allIds;
export const getCosAnnexeTRList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));


export const getCosAnnexeTRByCosAnnexeId = (state, cosAnnexeId) => getCosAnnexeTRList(state).filter(elem => elem.CosAnnexeId === cosAnnexeId);

